import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid, Paper, Text} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useTag} from '../hooks/useTag.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {useTagsSelection} from "../hooks/useTagsSelection.ts";

export const EditPage = () => {

    const {id: componentId} = useParams();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = useTag(componentId);

    const {handleClearSelection} = useTagsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (loading || !component) {
        return <PlatformLoader message='Loading tag...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.name ? component.name : component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Grid>
                    <Grid.Col span={{base: 4, sm: 12}}>
                        <Profile record={component}/>
                    </Grid.Col>
                    <Grid.Col span={{base: 8, sm: 12}}>
                        <Paper p="md" withBorder>
                            <Text>{component.description || 'No description provided'}</Text>
                        </Paper>
                    </Grid.Col>
                </Grid>
                :
                <SimplePageContentWrapper>
                    <RecordForm
                        record={component}
                        handleSubmit={updateRecord}
                    />
                </SimplePageContentWrapper>
            }


        </FormPageLayout>
    );
};
